import axios from 'axios';

const getApiBaseUrl = () => {
  const configuredApiUrl = process.env.REACT_APP_API?.replace(/\/+$/, '');

  if (!configuredApiUrl) {
    throw new Error('REACT_APP_API is not configured');
  }

  return `${configuredApiUrl}/api`;
};

const getEndpoint = endpoint => String(endpoint || '')
  .replace(/^\/+/, '')
  .replace(/^api\/+/, '');

export const strapiRequest = async ({
  method = 'get',
  endpoint,
  params,
  data
}) => {
  const normalizedEndpoint = getEndpoint(endpoint);

  try {
    const response = await axios({
      method,
      url: `${getApiBaseUrl()}/${normalizedEndpoint}`,
      params,
      data
    });

    return response.data;
  } catch (error) {
    const status = error.response?.status;
    const responseMessage = error.response?.data?.error?.message;
    const message = responseMessage || error.message || 'Unknown request error';
    const statusLabel = status ? ` (${status})` : '';

    throw new Error(
      `Strapi request failed${statusLabel}: ${method.toUpperCase()} /api/${normalizedEndpoint} — ${message}`
    );
  }
};
